module.exports = __webpack_public_path__ + "static/media/room3_2.91576993.JPG";